import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  overflow: "visible",
  preserveAspectRatio: "none",
  style: {"display":"block"},
  viewBox: "0 0 31.673 9.573"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", {
  fill: "var(--stroke-0, #FF6B6B)",
  d: "M31.483 5.246a.65.65 0 0 0 0-.92L27.346.19a.65.65 0 1 0-.92.92l3.678 3.677-3.677 3.677a.65.65 0 1 0 .919.919l4.137-4.137ZM0 4.786v.65h1.551v-1.3H0v.65Zm4.653 0v.65h3.103v-1.3H4.653v.65Zm6.205 0v.65h3.102v-1.3h-3.102v.65Zm6.205 0v.65h3.102v-1.3h-3.102v.65Zm6.204 0v.65h3.102v-1.3h-3.102v.65Zm6.205 0v.65h1.55v-1.3h-1.55v.65Z"
}, null, -1)
const _hoisted_3 = [
  _hoisted_2
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [..._hoisted_3]))
}
export default { render: render }